"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabItem = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function TabItem(props) {
    var active = props.active, disabled = props.disabled, component = props.component, children = props.children, style = props.style, rest = __rest(props, ["active", "disabled", "component", "children", "style"]);
    var _a = styles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    var className = css(classes.item, active && classes.active, disabled && classes.disabled) + ("" + (disabled ? ' disabled' : ''));
    var Cmp = component;
    return (react_1.default.createElement("li", { className: css(classes.li, style) },
        react_1.default.createElement(Cmp, __assign({ role: 'tab', className: className }, rest), children)));
}
exports.TabItem = TabItem;
TabItem.defaultProps = {
    component: 'span',
};
var createStyles = function (theme) { return ({
    li: {
        display: 'inline-block',
        '&:not(:first-child)': {
            marginLeft: '0.25rem',
        },
    },
    item: {
        display: 'inline-block',
        textDecoration: 'none',
        color: theme.pallete.text.main,
        fontWeight: 'bold',
        padding: 'calc(0.4375rem + 1px) 0.4375rem 0.4375rem 0.4375rem',
        lineHeight: '1rem',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        outline: 0,
        border: "1px solid " + theme.pallete.gray.c60,
        borderBottom: "none",
        background: theme.pallete.gray.c90,
        transition: 'background .15s, border-color .15s',
        '&:not(.disabled):hover': {
            cursor: 'pointer',
            background: theme.pallete.gray.c80,
        },
        '&:not(.disabled):active': {
            background: theme.pallete.gray.c80,
            boxShadow: theme.shadows.inner['10'],
        },
        '&:focus': {
            boxShadow: "inset 0 0 0 2px " + theme.pallete.primary.main,
            borderRadius: 4,
        },
    },
    active: {
        color: theme.pallete.primary.main,
        background: theme.pallete.gray.c100,
        borderTop: "4px solid " + theme.pallete.primary.main,
        paddingTop: 'calc(0.4375rem - 2px)',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            bottom: '-1px',
            left: '0',
            right: '0',
            height: '1px',
            background: theme.pallete.primary.c100,
        },
        '&:not(.disabled):hover': {
            background: theme.pallete.gray.c90,
        },
        '&:not(.disabled):active': {
            background: theme.pallete.gray.c90,
        },
    },
    disabled: {
        color: theme.pallete.text.disabled,
        '&:hover': {
            cursor: 'not-allowed',
        },
    },
}); };
//# sourceMappingURL=TabItem.js.map